import { startCase } from 'lodash';
import { MedicationType } from '../Contracts/MedicationModels';
import { MedicationExpiryType } from './Types';
export var renderItemToString = function (item) { return startCase(item.value); };
export var renderItemToMenuKey = function (item) { return item.value; };
export var renderMedicationExpiryName = function (item) {
    switch (item.value) {
        case MedicationExpiryType.Fixed:
            return 'Fixed duration';
        case MedicationExpiryType.Chart:
            return 'Chart duration';
    }
};
export var renderMedicationExpiryKey = function (item) { return item.value; };
// Need a fake witness to signify an external witness because
// without a selection the select won't render a selected item
export var externalWitnessId = 'external-witness';
export var externalWitnessSelection = {
    id: externalWitnessId,
    authoringSystem: '',
    authoringSystemForeignKey: '',
    title: null,
    givenName: '',
    familyName: '',
    staffRoles: [],
    prescriberDetails: null
};
export var freeTextClinicalIndicationCode = 'free-text-indication';
export var freeTextClinicalIndicationSelection = {
    code: freeTextClinicalIndicationCode,
    name: ''
};
export function prettyPrintOrderInstructionLabel(type) {
    switch (type) {
        case MedicationType.EnrmcScript:
        case MedicationType.ComplementaryTherapyOrder:
            return 'Administration dosage instructions';
        default:
            return 'Order instructions';
    }
}
export function prettyPrintDosageInstructionLabel(type) {
    switch (type) {
        case MedicationType.MedicationOrder:
        case MedicationType.EnrmcScript:
        case MedicationType.ComplementaryTherapyOrder:
            return 'Medical label instructions';
        default:
            return 'Dosage instructions';
    }
}
